<template>
    <div class="space-y-6">
        <SectionCard
            :showFlag="!detailsEntered"
            title="Quick Pay"
            description="Fill in the details before you pay.  We'll get the rest of your details later"
        >
            <button class="bg-ap-primary text-white px-4 py-2 text-sm rounded-lg">
                + Add a vehicle
            </button>

            <template v-slot:footer>
                <button class="bg-ap-fs-primary rounded-lg px-4 py-2 text-sm text-white">Continue</button>
            </template>
        </SectionCard>

        <SectionCard
            :showFlag="detailsEntered"
            title="Card Information"
        >
            <button @click="detailsEntered = false">Back</button>
            <StripePaymentForm></StripePaymentForm>
        </SectionCard>

        <popup-modal
                :show="showMessage"
                :title="error ? 'Error' : 'Please Wait'"
                :message="message"
                :success="error ? false : true"
                @close="showMessage = null"
        ></popup-modal>
    </div>
</template>

<script>
import PopupModal from './PopupModal.vue';
import SectionCard from './SectionCard.vue';
import StripePaymentForm from './StripePaymentForm.vue';

export default {
    data() {
        return {
            stripe: {},
            cardElement: {},
            paymentMethodId: null,
            error: null,
            csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            paymentProcessing: false,
            showMessage: false,
            messageTitle: '',
            message: '',
            detailsEntered: false,
        };
    },
    methods: {
        async processPayment() {
            this.paymentProcessing = true;
            this.error = null;
            this.message = null;

            this.payWithCard();
        },
        payWithCard() {
            this.stripe.confirmCardPayment(this.clientSecret, {
                payment_method: {
                    card: this.cardElement,
                },
            }).then((result) => {
                this.paymentProcessing = false;
                if (result.error) {
                    this.error = result.error.message;
                    this.message = this.error;
                    this.showMessage = true;
                } else {
                    this.paymentIntentId = result.paymentIntent.id;
                }
            });
        },
    },
    components: {
        PopupModal,
        SectionCard,
        StripePaymentForm,
    },
};
</script>
